import styled from 'styled-components';

export const TrustSectionContainer = styled.div`
  padding: 0 15% 5%;
  @media (max-width: 768px) {
    padding: 0 5% 5%;
  }
`;
export const TrustInner = styled.div`
  display: flex;
  gap: 16px;
  @media (max-width: 720px) {
    flex-direction: column;
  }
  .joySection {
    flex-basis: 50%;
    @media (max-width: 720px) {
      flex-basis: 100%;
    }
  }
`;

export const DownloadSection = styled.div`
  .mobileSection {
    display: none;
    @media (max-width: 720px) {
      display: block;
    }
  }
  .desktopSection {
    display: block;
    @media (max-width: 720px) {
      display: none;
    }
  }
  margin-top: 5%;
  position: relative;
  img {
    width: 40%;
  }
  .btnContainer {
    position: absolute;
    top: 80%;
    left: 5%;
  }
  .mobilebtnContainer {
    position: absolute;
    top: 10%;
    left: 47%;
    width: 50%;
  }
`;

export const Download = styled.button`
  background: #fffcf5;
  width: fit-content;
  font-size: clamp(14px, 2vw, 14px);
  color: #2f2f2f;
  cursor: pointer;
  font-weight: 500;
  border-radius: ${(props) =>
    props.rightBtn ? '0 26px 26px 0' : '26px 0 0 26px'};
  padding: 18px 16px;
  border: none;
  margin-right: 8px;
  @media (max-width: 768px) {
    width: 35%;
  }
`;
export const ToolsSection = styled.div`
  flex-basis: 50%;
  background: #f1f7f5;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 720px) {
    flex-basis: 100%;
  }
  img {
    width: 90%;
    @media (max-width: 720px) {
      width: 100%;
    }
  }
`;
